/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useUpdateComponent } from "cms/components/hooks/use-update-component";
import { CarouselComponentEditWrapper } from "cms/components/components/hero-carousel/edit/component-carousel-wrapper";
import { HeroCarouselSlideEditor } from "cms/components/components/hero-carousel/edit/hero-carousel-slide-editor";
import { ErrorBoundary } from "react-error-boundary";
import { FieldErrorFallback } from "cms/fields/layout/field-error";

const HeroCarouselComponentEditor = () => {
    
    const { component, update } = useUpdateComponent();
    const { slides } = component;
    // console.log('[onChangeList] original',slides)
    
    const onChangeList = (slides) => {
        // console.log('[onChangeList] slides',slides)
        update("slides", slides);
    };
    
    return (
        <div className='simplicity-editor-frame'>
            <ErrorBoundary
                FallbackComponent={FieldErrorFallback}
                onReset={() => {
                    location.reload(); 
                }}
            >
                <CarouselComponentEditWrapper
                    slides={slides}
                    onChangeList={onChangeList}
                >
                    
                    {/* Hero Carousel Slide */}
                    <HeroCarouselSlideEditor />
                    
                </CarouselComponentEditWrapper>
            </ErrorBoundary>
        </div>
    );
};
HeroCarouselComponentEditor.displayName = "HeroCarouselComponentEditor";
export { HeroCarouselComponentEditor };
